import React from 'react'
import {
  useModelKey,
  useModelValue,
  useValue
} from '@morningtrain/react-resources'
import RemoveFromCartOnClick from 'services/cart/RemoveFromCartOnClick'
import SVGIcon from 'ui/helpers/SVGIcon'
import { observer } from 'mobx-react'

function RemoveFromCart (props) {
  const id = useModelKey()
  const name = useValue('domain')
  const price = useValue('discounted_price')
  const quantity = useModelValue('quantity', 1)

  return (
    <RemoveFromCartOnClick id={id} quantity={quantity} name={name} price={price}>
      <button className='mt-1 rounded-full outline-none focus:shadow-outline'><SVGIcon type='cancel' color='#E74C3C' className='w-4 h-4' /></button>
    </RemoveFromCartOnClick>
  )
}

export default observer(RemoveFromCart)
